import React from "react";

export const AlertContext = React.createContext();

export const AlertContextProvider = ({ children }) => {
  const alert = React.useRef();
  const qr = React.useRef();
  const successEmail = React.useRef();
  const about = React.useRef();
  const skills = React.useRef();
  const project = React.useRef();
  const contact = React.useRef();
  

  const handleScroll = (ref) => {
    ref.current.scrollIntoView({behavior:"smooth"});
  }

  const displayAlert = () => {
    alert.current.style.display = "block";
  };

  const hideAlert = () => {
    alert.current.style.display = "none";
  };

  const displayQr = () => {
    qr.current.style.display = "block";
  };

  const hideQr = () => {
    qr.current.style.display = "none";
  };

  const successShow = () => {
    console.log("hello", successEmail);
    successEmail.current.style.display = "block";
  };

  const successHide = () => {
    successEmail.current.style.display = "none";
  };

  return (
    <AlertContext.Provider
      value={{
        alert,
        displayAlert,
        hideAlert,
        qr,
        hideQr,
        displayQr,
        successEmail,
        successShow,
        successHide,
        contact,
        about,
        skills,
        project,
        handleScroll
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};
